"use client";
import { useEffect, useLayoutEffect, useState } from "react";

export function useMediaQuery() {
  const [matches, setMatches] = useState<boolean>(true);
  useEffect(() => {
    const mediaQueryList = window.matchMedia("(min-width: 768.5px)");
    const listener = () => setMatches(!!mediaQueryList.matches);
    listener();
    mediaQueryList.addEventListener("change", listener); // updated from .addListener
    return () => mediaQueryList.removeEventListener("change", listener); // updated from .removeListener
  }, []);

  useLayoutEffect(() => {
    if (window) {
      setMatches(window.innerWidth > 768);
    }
  }, []);

  return matches;
}
